import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IResult } from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "../../../../services/abstract.service";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";
import { ICreateOrder } from "./interfaces/create-order-delivery.interface";
const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_list_delivery_windows";

@Injectable({
  providedIn: "root",
})
export class MaterialListDeliveryWindowService extends AbstractService<
  orderDeliveryWindowsAttributes,
  ICreateOrder,
  null
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialListId(
    materialListId: string
  ): Observable<IResult<orderDeliveryWindowsAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialListId}`;
    return this.http.get<IResult<orderDeliveryWindowsAttributes>>(API_URL);
  }
}
